module.exports = __webpack_public_path__ + "src/img/up.a6137e3e.svg";